import React from "react";
import "./TurnosDisponibles.css";

const TurnosDisponiblesTxt = ({fecha}) => {
  return (
    <React.Fragment>
      <div className="ptur-turnosDisponibles-noEcontrados-texto">
        <span>
          <p className="rb18b">No se encontraron turnos disponibles el {fecha}.</p>
          <p className="rb16l">
            Recomendamos que modifiques la fecha o busques por próximos turnos
            disponibles:
          </p>
        </span>
      </div>
    </React.Fragment>
  );
};

export default TurnosDisponiblesTxt;
